import { render, staticRenderFns } from "./launcher.vue?vue&type=template&id=b945e02a&scoped=true&lang=pug&"
import script from "./launcher.vue?vue&type=script&setup=true&lang=js&"
export * from "./launcher.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./launcher.vue?vue&type=style&index=0&id=b945e02a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b945e02a",
  null
  
)

export default component.exports